import { render, staticRenderFns } from "./AppProperty.vue?vue&type=template&id=45ddab03&scoped=true"
import script from "./AppProperty.vue?vue&type=script&lang=ts"
export * from "./AppProperty.vue?vue&type=script&lang=ts"
import style0 from "./AppProperty.vue?vue&type=style&index=0&id=45ddab03&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45ddab03",
  null
  
)

export default component.exports